import { createAction, props } from '@ngrx/store';
import { AbsenceListItemResponse, DeclineRequest, PaginatedApiResponse, ProfileResponse3 } from '../../../api';
import { BaseAbsenceRequestsListPayloadInterface } from '../../modules/absence-requests/_interfaces/base-absence-requests-list-payload.interface';

export const loadAbsenceRequests = createAction(
  '[Absence Requests] Load list',
  props<{ payload: BaseAbsenceRequestsListPayloadInterface }>()
);
export const setAbsenceRequests = createAction(
  '[Absence Requests] Set list',
  props<{ payload: PaginatedApiResponse & { data?: AbsenceListItemResponse[] } }>()
);
export const successAbsenceRequests = createAction('[Absence Requests] Success load list');
export const errorAbsenceRequests = createAction('[Absence Requests] Error load list');

// Dashboard tile: first page of pending requests plus the overall pending count
export const loadDashboardAbsenceRequests = createAction('[Absence Requests] Load dashboard list');
export const setDashboardAbsenceRequests = createAction(
  '[Absence Requests] Set dashboard list',
  props<{ payload: PaginatedApiResponse & { data?: AbsenceListItemResponse[] } }>()
);
export const successDashboardAbsenceRequests = createAction('[Absence Requests] Success load dashboard list');
export const errorDashboardAbsenceRequests = createAction('[Absence Requests] Error load dashboard list');

// Employee filter options (typeahead over the PSP's active profiles)
export const loadEmployees = createAction(
  '[Absence Requests] Load employees',
  props<{ payload: { search: string } }>()
);
export const setEmployees = createAction('[Absence Requests] Set employees', props<{ payload: ProfileResponse3[] }>());
export const successEmployees = createAction('[Absence Requests] Success load employees');
export const errorEmployees = createAction('[Absence Requests] Error load employees');

// Dispatcher decisions (KS-7098)
export const approveAbsenceRequest = createAction(
  '[Absence Requests] Approve request',
  props<{ payload: { absence: number } }>()
);
export const successApproveAbsenceRequest = createAction('[Absence Requests] Success approve request');
export const errorApproveAbsenceRequest = createAction('[Absence Requests] Error approve request');
export const declineAbsenceRequest = createAction(
  '[Absence Requests] Decline request',
  props<{ payload: { absence: number; body: DeclineRequest } }>()
);
export const successDeclineAbsenceRequest = createAction('[Absence Requests] Success decline request');
export const errorDeclineAbsenceRequest = createAction('[Absence Requests] Error decline request');
